export default "__VITE_ASSET__oKlhi8nl__"